module.exports = __webpack_public_path__ + "static/media/profilepic.121c61be.jpg";